"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouponType = void 0;
var CouponType;
(function (CouponType) {
    CouponType["cancellationDiscount"] = "cancellation-discount";
})(CouponType = exports.CouponType || (exports.CouponType = {}));
//# sourceMappingURL=CouponType.js.map